import vTextHighlight from '@/directives/text-highlight.js'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('text-highlight', vTextHighlight)
})
